import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxsModule } from '@ngxs/store';

/* Modules */
import { MaterialModule } from '../../material.module';
import { SharedModule } from '../../shared/shared.module';

/* Services */
import { UsersService } from './services/users.service';

/* States */
import { UsersState } from './users.state';

/* Components */
import { UsersListPageComponent } from './components/users-list-page/users-list-page.component';
import { CreateCsaUserComponent } from './components/create-csa-user/create-csa-user.component';
import { DeleteConfirmationDialogComponent } from './components/delete-confirmation-dialog/delete-confirmation-dialog.component';

@NgModule({
  imports: [
    FormsModule,
    HttpClientModule,
    CommonModule,
    NgbModule,
    MaterialModule,
    NgxDatatableModule,
    ReactiveFormsModule,
    NgxsModule.forFeature([
      UsersState
    ]),
    SharedModule
  ],
  declarations: [
    UsersListPageComponent,
    CreateCsaUserComponent,
    DeleteConfirmationDialogComponent
  ],
  providers: [UsersService],
  exports: []
})
export class UsersModule {
}
